@if (content) {
<div class="bg-col-5-x bg-col-5-l flex flex-column-reverse-m flex-column-reverse-s">
    <div class="w-5 w-12-m w-12-s p-l-10 p-l-6-l p-l-3-m p-l-4-s m-t-4-m m-t-6-s flex flex-middle">
        @if (category) {
        <div class="w-10-x w-10-l p-r-3 p-r-4-m p-r-6-s p-l-12-x">
            <!-- category name -->
            <h1 class="h2 m-b-2 m-b-3-s">{{category.data?.name | facetOverride : category.id : 'h1'}}</h1>
            <!-- category description -->
            @if (category) {
            <read-more class="p1 col-1"
                       [text]="category.data?.description | facetOverride : category.id : 'description'"
                       [limit]="170"
                       [readLess]="true">
            </read-more>
            }
        </div>
        }
    </div>
    <!-- image -->
    @if (content.image) {
    <div class="w-7 w-12-m w-12-s">
        <df-image-wrapper>
            <img class="z-1"
                 [ratio]="client.sizeId > 1 ? 'ratio-7-3' :  'ratio-3-2'"
                 [dfImage]="content.image">
            @if (content.contentVariant === contentVariant.video) {
            @if (content.contentVideoProvider === contentVideoProvider.vimeo) {
            <vimeo-player class="fill z-2"
                          [video-id]="content.contentVideoId"
                          [background]="true"
                          [loop]="true">
            </vimeo-player>
            }
            @if (content.contentVideoProvider === contentVideoProvider.youtube) {
            <youtube-player class="fill z-2"
                            [video-id]="content.contentVideoId">
            </youtube-player>
            }
            }
        </df-image-wrapper>
    </div>
    }
</div>
}